import { centerInStrip, findAll } from './dom';

// Teme kalendara su traka pilula koja se prevlači: tema izabrana u adresi (?tema=, iz ponude stonog uz zidni kalendar) je
// na sredini trake, da je kupac odmah vidi. Bez skripte traka počinje od prve teme.
export function enhanceSwatchStrip(): void {
  findAll(document, 'swatch-strip', HTMLElement).forEach(strip => {
    const chosen = strip.querySelector('[aria-current="true"]');
    if (chosen instanceof HTMLElement) centerInStrip(strip, chosen);
  });
}
